import * as XLSX from "xlsx";

const getFileName = (name: string) => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    let timeSpan = mm + '/' + dd + '/' + yyyy;
    //let timeSpan = new Date().toISOString();
    let sheetName = name || "ExportResult";
    let fileName = `${sheetName}-${timeSpan}`;
    return {
        sheetName,
        fileName
    };
};

export class TableUtil {
  static exportTableToExcel(tableId: string, name: string) {
    try
    {
        let { sheetName, fileName } = getFileName(name);
        let targetTableElm = document.getElementById(tableId);
        let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{
        sheet: sheetName,
        raw: true,
        });

        XLSX.writeFile(wb, `${fileName}.xlsx`);
    }
    catch
    {
        return false
    }
    
    return true
  }

  static exportArrayToExcel(arr: any[], name: string) {
  try 
  {
    let { sheetName, fileName } = getFileName(name);

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet(arr);
    XLSX.utils.book_append_sheet(wb, ws, sheetName,);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
  catch
  {
      return false
  }
  return true
  }
}
